import { useEffect, useState } from 'react';

import { theme } from '../../styles';

export const useIsDeviceSize = () => {
  const minMediumQuery = `(min-width: ${theme.breakpoint.md}px)`;
  const minLargeQuery = `(min-width: ${theme.breakpoint.lg}px)`;
  const mediaQueryListMedium = window.matchMedia(minMediumQuery);
  const mediaQueryListLarge = window.matchMedia(minLargeQuery);

  const [isMobile, setIsMobile] = useState(!mediaQueryListMedium.matches);
  const [isTablet, setIsTablet] = useState(mediaQueryListMedium.matches && !mediaQueryListLarge.matches);
  const [isDesktop, setIsDesktop] = useState(mediaQueryListLarge.matches);

  useEffect(() => {
    const handlerMedium = () => {
      setIsMobile(!mediaQueryListMedium.matches);
      setIsTablet(mediaQueryListMedium.matches && !mediaQueryListLarge.matches);
    };
    const handlerLarge = () => {
      setIsTablet(mediaQueryListMedium.matches && !mediaQueryListLarge.matches);
      setIsDesktop(mediaQueryListLarge.matches);
    };
    mediaQueryListMedium.addEventListener('change', handlerMedium, { passive: true });
    mediaQueryListLarge.addEventListener('change', handlerLarge, { passive: true });

    return () => {
      mediaQueryListMedium.removeEventListener('change', handlerMedium);
      mediaQueryListLarge.removeEventListener('change', handlerLarge);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return { isMobile, isTablet, isDesktop };
};
